/**
 * A custom accordion component
 *
 * @component 
 */

class custAccordion {


    constructor(){
        let self = this;
        self.init();
    }

    init() {

        if ($('[data-custaccordion]').length === 0) return;

        $('[data-custaccordion]').each(function(item,component){

            // if the custaccordion data att is not empty. It expects the class of the target element
            let target = $(component).data('custaccordion'); 
            let $target = '';

            if (target !== '') {
                $target = $('.'+target);
            }else{
                $target = $(this).next('[data-custaccordioncontent]');
            }


            $(component).on('click',function(e){
                e.preventDefault();

                //$target.slideToggle();

                $target.toggleClass('has-max-height');
            })

        })

    }

}

export default new custAccordion();
